import { render } from "./PopUp.vue?vue&type=template&id=33dde81b"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=33dde81b&lang=scss"

import exportComponent from "/mnt/d/Projetos/Carneiros Temporada/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__